var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"hero is-info"},[_c('div',{staticClass:"hero-head"}),_c('div',[_vm._t("hero-body")],2),_c('div',{staticClass:"hero-foot"},[_vm._t("hero-foot")],2)]),_c('div',{staticClass:"container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }